<script setup lang="ts">
import { useCategoryStore } from '~~/stores/category'
defineOptions({
  name: 'KategoriAside'
})
const categoryStore = useCategoryStore()
const categories = computed(() => categoryStore.state.categories)
</script>

<template>
  <aside class="kategori-aside">
    <h3 class="kategori-aside__title">Kategori</h3>

    <nav>
      <ul>
        <template v-if="categories?.isLoading">
          <li v-for="index in 5" :key="index" class="px-5 mb-4">
            <LazyAtomsSkeleton height="24px" width="100%" />
          </li>
        </template>
        <li v-else-if="!categories?.isLoading && !categories.data?.length">
          <AtomsEmpty height="200px" description="Kategori tidak ditemukan" />
        </li>
        <template v-else>
          <li
            v-for="(category, index) in categories?.data"
            :id="`category-${category?.serial}`"
            :key="index"
            :span="12"
          >
            <NuxtLink
              :to="`/kategori/${category?.serial}`"
              :class="
                category?.serial === $route.params?.serial ? 'active' : null
              "
            >
              {{ category.name }}
            </NuxtLink>
          </li>
        </template>
      </ul>
    </nav>
  </aside>
</template>

<style lang="scss">
@use './styles.scss';
</style>
